"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogEventColor = exports.LogEventIcon = exports.LogEvent = exports.LogChartTopType = exports.LogTopType = void 0;
// 排行榜类型
exports.LogTopType = {
    设备型号用户量: 1,
    城市名称访问用户量: 2,
    系统版本用户量: 3,
    应用版本访问用户量: 4,
    设备分辨率量: 5,
    浏览器访问用户量: 6,
    1: '设备型号用户量',
    2: '城市名称访问用户量',
    3: '系统版本用户量',
    4: '应用版本访问用户量',
    5: '设备分辨率量',
    6: '浏览器访问用户量',
};
// 排行榜类型
exports.LogChartTopType = {
    设备型号用户量: 'barChartTopEquipment',
    城市名称访问用户量: 'barChartTopCity',
    系统版本用户量: 'barChartTopSystem',
    应用版本访问用户量: 'barChartTopApp',
    设备分辨率量: 'barChartTopResolving',
    浏览器访问用户量: 'barChartTopBrowser',
};
// 埋点
exports.LogEvent = {
    登陆: 'E100000001',
    退出登陆: 'E100000002',
    启动: 'E100000006',
    显示: 'E100000007',
    进入后台: 'E100000008',
    分享: 'E100000009',
    页面浏览: 'E100000010',
    元素点击: 'E100000011',
    跳出事件: 'E100000014',
    客户端错误事件: 'E100000015',
    api请求: 'E100000016',
    E100000001: '登陆',
    E100000002: '退出登陆',
    E100000006: '启动',
    E100000007: '显示',
    E100000008: '进入后台',
    E100000009: '分享',
    E100000010: '页面浏览',
    E100000011: '元素点击',
    E100000014: '跳出事件',
    E100000015: '客户端错误事件',
    E100000016: 'api请求',
};
// 埋点
exports.LogEventIcon = {
    登陆: 'el-icon-document-checked',
    退出登陆: 'el-icon-document-delete',
    启动: 'el-icon-document-copy',
    显示: 'el-icon-document-add',
    进入后台: 'el-icon-document-remove',
    分享: 'el-icon-share',
    页面浏览: 'el-icon-document',
    元素点击: 'el-icon-thumb',
    跳出事件: 'el-icon-light-rain',
    客户端错误事件: 'el-icon-warning-outline',
    api请求: 'el-icon-s-promotion',
};
// 埋点
exports.LogEventColor = {
    登陆: 'rgb(49, 201, 204)',
    退出登陆: 'rgb(248, 81, 73)',
    启动: 'rgb(49, 201, 204)',
    显示: 'rgb(49, 201, 204)',
    进入后台: 'rgb(248, 81, 73)',
    分享: 'rgb(33, 136, 255)',
    页面浏览: 'rgb(49, 201, 204)',
    元素点击: 'rgb(255, 147, 38)',
    跳出事件: 'rgb(248, 81, 73)',
    客户端错误事件: 'rgb(248, 81, 73)',
    api请求成功: '#4c9fff',
    api请求错误: 'rgb(248, 81, 73)',
};
